import VolumeControl from './volumecontrol'

export default VolumeControl
